import { cnpjMask } from "../../../../../../../../../../../utils/mask";
import {
  formatDateToBR,
  formatHoursToBRWithoutSeconds,
} from "../../../../../../../../../../../utils/time";

export const tableColumnsRecusaram = [
  {
    id: "id",
    label: "Cód.",
  },
  {
    id: "dataCriacao",
    label: "Data",
    customField: formatDateToBR,
  },
  {
    id: "dataCriacao",
    label: "Hora",
    customField: formatHoursToBRWithoutSeconds,
  },
  {
    id: "cpf",
    label: "CPF",
  },
  {
    id: "cnpj",
    label: "CNPJ",
    customField: cnpjMask,
  },
  {
    id: "porte",
    label: "Porte",
  },
  {
    id: "uf",
    label: "UF",
  },
  {
    id: "cidade",
    label: "Cidade",
  },
  {
    id: "atendente",
    label: "Agente",
  },
];
